export class WindowProfileUserModel{
    windowId: number = 0;
    profileUserId: number = 0;
    updatable: boolean = false;
}